import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Commandes',
  buttons: {
    actions: 'Actions',
    [action_create_dummy_order]: 'Créer une commande test',
    [action_launch_orders_portal_app]: 'Lancer le portail des commandes',
    show_order_details: 'Voir les détails de la commande',
    track_order: 'Suivre la commande',
    update_dropoff_time: "Mettre à jour l'heure de dépôt",
    download_receipt: 'Télécharger le reçu',
    open_payment_page: 'Ouvrir la page de paiement',
  },
  form: {
    customer_details: {
      placeholder: 'Nom ou numéro de téléphone du client',
    },
    amount_min: {
      placeholder: 'Montant min',
    },
    amount_max: {
      placeholder: 'Montant max',
    },
    utm_source: {
      placeholder: 'Saisir la source utm',
    },
    utm_medium: {
      placeholder: 'Saisir le medium utm',
    },
    utm_campaign: {
      placeholder: 'Saisir la campagne utm',
    },
    utm_advertisement_id: {
      placeholder: "Saisir l'id de publicité utm",
    },
  },
  labels: {
    // A table order's table under its method: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Table {{name}}',
    no_orders: "Aucune commande pour l'instant",
    total_orders: 'Total des commandes',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'À emporter',
    [ORDER_METHODS.delivery]: 'Livraison',
    [ORDER_METHODS.on_site]: 'Commande à table',
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'En attente',
    [ORDER_PAYMENT_STATUSES.paid]: 'Payé',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Partiellement remboursé',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Remboursé',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: "En attente d'approbation",
      [FULFILLMENT_STATUSES.reviewed]: "En attente d'approbation",
      [FULFILLMENT_STATUSES.accepted]: 'En cours',
      [FULFILLMENT_STATUSES.preparing]: 'En cours',
      [FULFILLMENT_STATUSES.ready]: 'En cours',
      [FULFILLMENT_STATUSES.on_delivery]: 'En cours',
      [FULFILLMENT_STATUSES.picked]: 'Terminé',
      [FULFILLMENT_STATUSES.rejected]: 'Rejeté',
      null: 'Inconnu',
      undefined: 'Inconnu',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'À emporter',
    internal_delivery: 'Livraison interne',
    external_delivery: 'Livraison externe',
    on_site: 'Commande à table',
    scheduled: 'Planifié',
    reward: 'Récompense',
    mobile: 'Mobile',
    invoice: 'Facture',
    cash: 'Espèces',
    rejected_automatically: 'Rejeté automatiquement',
    rejected_manually: 'Rejeté manuellement',
    call_center: "Centre d'appels",
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    tags: 'Tags',
    order_placed: 'Commande passée',
    ready_at: 'Commande prête',
    customer: 'Client',
    items: 'Articles',
    method: 'Méthode',
    payment_status: 'Statut du paiement',
    fulfillment_status: 'Statut',
    total: 'Total',
    utm_source: 'Source UTM',
    utm_medium: 'Support UTM',
    utm_campaign: 'Campagne UTM',
    utm_advertisement_id: 'Id publicitaire UTM',
  },
  metrics: {
    total_orders: 'Total des commandes',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_create_dummy_order: 'Échec de la création de la commande test',
    dummy_order_created: 'Commande test créée',
    failed_to_launch_orders_portal_app: 'Échec du lancement du portail de commandes',
    failed_to_download_receipt: 'Échec du téléchargement du reçu',
  },
};
